import { Heap } from '@/monitoring/heap'
import { type HeapEventsType } from './heapEvents'

export function trackHeapEvent(eventId: HeapEventsType, data?: object) {
  Heap.track(eventId, data)
}
